export default __webpack_public_path__ + "static/media/mapspin-icon.32a3d1a0.svg";